import { actions } from '../../stores/multipost'
import axios from '../shared/axios'

export async function fetchSuggestions(key, state, dispatch) {
    if (state.suggestions[key].loading) {
      return
    }

    try {
      dispatch({ type: actions.SET_SUGGESTIONS, key: key, value: [], loading: true, error: false })

      const providers = key === 'default' ? state.selectedAccounts : [key]
      const files = state.selectedFiles.map(file => ({
        id: file.id,
        type: file.type === 'graphic' ? 'graphic' : 'upload'
      }))

      let response = await axios.post(`suggestions`, {
        team_post_suggestion: {
          providers: providers,
          files: files
        }
      })

      const startTime = Date.now()
      const timeoutDuration = state.suggestionTimeoutSecs * 1000
      let pollIntervals = [3_000, 1_000, 1_000, 2_000]

      while (response.data.poll_path) {
        if (Date.now() - startTime >= timeoutDuration) {
          throw new Error("Request timed out")
        }

        await new Promise((resolve) => setTimeout(resolve, pollIntervals.shift() || 3_000))
        response = await axios.get(response.data.poll_path)
      }

      if (response.data.status != 'completed') {
        dispatch({ type: actions.SET_SUGGESTIONS, key: key, loading: false, error: true })
      } else {
        dispatch({
          type: actions.SET_SUGGESTIONS,
          key: key,
          value: response.data.messages || [],
          loading: false,
          error: false,
          promptLogId: response.data.prompt_log_id
        })
      }
    } catch (error) {
      dispatch({ type: actions.SET_SUGGESTIONS, key: key, loading: false, error: true })
    }
  }